"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducers = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var initReducers_1 = require("../init/initReducers");
var loadAttributeReducers_1 = require("../loadAttribute/loadAttributeReducers");
var loadCustomElementsReducers_1 = require("../loadCustomElements/loadCustomElementsReducers");
var loadInitialElementsPageReducers_1 = require("../loadInitialElementsPage/loadInitialElementsPageReducers");
var loadNextElementsPageReducers_1 = require("../loadNextElementsPage/loadNextElementsPageReducers");
var selectionReducers_1 = require("../selection/selectionReducers");
var elementsReducers_1 = require("../elements/elementsReducers");
/**
 * @internal
 */
exports.rootReducers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, initReducers_1.initReducers), loadAttributeReducers_1.loadAttributeReducers), loadInitialElementsPageReducers_1.loadInitialElementsPageReducers), loadNextElementsPageReducers_1.loadNextElementsPageReducers), loadCustomElementsReducers_1.loadCustomElementsReducers), selectionReducers_1.selectionReducers), elementsReducers_1.elementsReducers);
//# sourceMappingURL=rootReducers.js.map